(function() {
    'use strict';

    /**
     * @ngdoc directive
     * @name gbNewEmailSelectV2
     *
     * @description
     * Directive for permissions V2 user and group typeahead.
     */
    angular.module('GorillaBoy.directives')
    .directive('gbEmailSelect', [
        '$rootScope',
        '$q',
        '$timeout',
        '$translate',
        '$filter',
        'TypeaheadService',
        'UserService',
        'authenticatedUser',
        'SignalProvider',
        'ResourceService',
        'searchDelay',
        'SourceConstant',
        'AppConstants',
        'FeatureManagerService',
        EmailSelectDirective
    ]);

    function EmailSelectDirective($rootScope, $q, $timeout, $translate, $filter, TypeaheadService, UserService, authenticatedUser, SignalProvider, ResourceService, searchDelay, SourceConstant, AppConstants, FeatureManagerService) {
        return {
            restrict: 'E',
            scope: {
                collaborators: '=',
                removedCollaborators: '=',
                sharedPrincipals: '=',
                excludeSelf: '=',
                filterActivePending: '=',
                currentOwnerUsername: '=',
                currentOwnerInfo: '=',
                collaboratorRoleUpdated: '=',
                openFeedback: '=',
                feedbackRequested: '=',
                allFeedbackRequested: '=',
                numContributors: '=',
                showGroupAndNonContributorMessage: '='
            },
            templateUrl: './share-modal/email_select.html',
            link: function(scope, element, attrs) {
                // AppConstant bindings
                var collaboratorTypes = AppConstants.CollaboratorTypes,
                    globalRoles = AppConstants.GlobalRoles,

                    numFeedbackRequests = 0;

                $('.email-list').scroll(function() {
                    $('.menu-list').hide();
                });

                scope.GlobalRoles = globalRoles;
                scope.collaboratorTypes = collaboratorTypes;
                scope.role = globalRoles.CONTRIBUTOR;
                scope.userInput= {searchQuery: ''};
                scope.groups = [];
                scope.documentShare = {
                    principals: null
                };
                scope.metadata = null;
                scope.shareErrMessage = '';

                // Add a user or anonymous result wrapper.
                function addUserCollaboratorWrapper(userCollaboratorWrapper) {
                    var username = userCollaboratorWrapper.metadata.Username,
                        existingUserCollaboratorWrapper = null,
                        userValue = null;

                    // Do not process empty strings.
                    if (!$rootScope.filterZerolengthStrings(username)) {
                        return;
                    }

                    // Exclude the current user.
                    if (scope.excludeSelf && authenticatedUser.getUserInfo().Username === username) {
                        scope.shareErrMessage = $translate.instant('SHARING.ERROR_CANNOT_SHARE_WITH_SELF');
                        return;
                    }

                    if (scope.sharedPrincipals) {
                        for (var i = 0; i < scope.sharedPrincipals.direct.length; i++) {
                            var sharedPrincipal = scope.sharedPrincipals.direct[i];
                            if (sharedPrincipal.Type !== collaboratorTypes.GROUP && sharedPrincipal.Username === username) {
                                scope.shareErrMessage = $translate.instant('SHARING.ERROR_ALREADY_SHARED');
                                return;
                            }
                        }
                    }

                    // Only for an anonymous user, verify that the input is a valid email address.
                    if (userCollaboratorWrapper.type === collaboratorTypes.INVITE && $rootScope.filterInvalidEmail(username)) {
                        scope.shareErrMessage = $translate.instant('SHARING.ERROR_INVALID_USERNAME_OR_EMAIL');
                        return;
                    }

                    angular.forEach(scope.collaborators, function(collaborator) {
                        if (collaborator.type !== collaboratorTypes.GROUP && collaborator.metadata.Username === username) {
                            existingUserCollaboratorWrapper = collaborator;
                        }
                    });

                    if (!existingUserCollaboratorWrapper) {
                        userValue = $('#default-roles').attr('value');                        
                        if(userCollaboratorWrapper.metadata.MinimalUser === true){
                        	userValue = 'VIEWER';
                        }
                        userCollaboratorWrapper.roleType = userValue;
                        scope.collaborators.push(
                            userCollaboratorWrapper
                        );

                        if (userValue && userValue === globalRoles.CONTRIBUTOR) {
                            processNewContributor(userCollaboratorWrapper);
                        }
                    }
                }

                // Add a group result wrapper.
                function addGroupCollaboratorWrapper(groupCollaboratorWrapper) {
                    var groupName = groupCollaboratorWrapper.metadata.Name,
                        existingGroupCollaboratorWrapper = null,
                        groupValue = null;

                    for (var i = 0; i < scope.sharedPrincipals.direct.length; i++) {
                        var sharedPrincipal = scope.sharedPrincipals.direct[i];
                        if (sharedPrincipal.Type === collaboratorTypes.GROUP && sharedPrincipal.Name === groupName) {
                            scope.shareErrMessage = $translate.instant('SHARING.ERROR_ALREADY_SHARED');
                            return;
                        }
                    }

                    angular.forEach(scope.collaborators, function(collaborator) {
                        if (collaborator.type === collaboratorTypes.GROUP && groupName === collaborator.metadata.Name) {
                            existingGroupCollaboratorWrapper = collaborator;
                        }
                    });

                    if (!existingGroupCollaboratorWrapper) {
                        groupValue = $('#default-roles').attr('value');
                        groupCollaboratorWrapper.roleType = groupValue;
                        scope.collaborators.push(
                            groupCollaboratorWrapper
                        );
                    }
                }

                /**
                 * Search users and groups. Notify the typeahead if one of them is returned from the service.
                 * Then, resolve the typeahead promise with the remaining list.
                 */
                var userAndGroupResults = [],
                    userResults = [],
                    groupResults = [],
                    lastSearchUid = null,
                    searchUid = 0,
                    TOTAL_NUM_REQUESTS = 2;

                function resultsWithNewUsers(users) {
                    userResults = users;
                    userAndGroupResults = userResults.concat(groupResults);
                    return userAndGroupResults;
                }

                function resultsWithNewGroups(groups) {
                    groupResults = groups;
                    userAndGroupResults = userResults.concat(groupResults);
                    return userAndGroupResults;
                }

                scope.shouldDisableTypeAhead = function () {
                    return FeatureManagerService.isFeatureEnabled($rootScope.Features.UI.DISABLE_TYPEAHEAD_DURING_INVITE);
                };

                scope.searchUserAndGroup = function(query) {
                    var deferred = $q.defer(),
                        localRequestId = searchUid,
                        completeCount = 0,
                        searchUsersParams = {
                            excludeSelf: scope.excludeSelf,
                            includeInactiveUsers: scope.filterActivePending,
                            currentUsername: scope.currentOwnerUsername,
                            reuseLastSearchOnError: true
                        };

                    // Search a user without a delay, and make the last request update user results.
                    lastSearchUid = searchUid;
                    searchUid += 1;

                    TypeaheadService.searchUsers(query, searchUsersParams).then(
                        function resolveSuccess(userCollaboratorWrappers) {
                            completeCB(userCollaboratorWrappers, resultsWithNewUsers);
                        },
                        function resolveFailure() {
                            completeCB([], resultsWithNewUsers);
                        });

                    TypeaheadService.searchGroups(query).then(
                        function resolveSuccess(groupCollaboratorWrappers) {
                            completeCB(groupCollaboratorWrappers, resultsWithNewGroups);
                        },
                        function resolveFailure() {
                            completeCB([], resultsWithNewGroups);
                        });

                    function completeCB(results, resultsFn) {
                        // All old search results will be ignored.
                        if (lastSearchUid === localRequestId) {
                            completeCount += 1;

                            if (completeCount === TOTAL_NUM_REQUESTS) {
                                deferred.resolve(resultsFn(results));
                            } else {
                                deferred.notify(resultsFn(results));
                            }
                        }
                    }

                    return deferred.promise;
                };

                scope.addUserToInviteeList = function(userInput) {
                    if ($rootScope.filterInvalidEmail(userInput)) {
                        scope.shareErrMessage = $translate.instant('SHARING.ERROR_INVALID_USERNAME_OR_EMAIL');
                    }else{
                        scope.shareErrMessage = '';
                        
                        scope.searchUserAndGroup(userInput).then( function (collaborator) {  
                            // collaborator.length cannot be zero - because if we don't find it, we 'invite'                  
                            if(collaborator.length === 1) { 
                                scope.addCollaboratorWrapper(collaborator[0]);
                            } 
                            // else: collaborator length is more than one -- Currently we dont see a possiblity.
                        } );
                    }
                };

                scope.typeAheadSelect = function(collaborator) {
                    scope.addCollaboratorWrapper(collaborator);
                };

                scope.changeFeedbackRequested = function(user) {
                    // User can be a collaborator or a sharedPrincipal.
                    // Only allow selection if the user is a contributor.
                    if ((user.Role && (user.Role !== globalRoles.CONTRIBUTOR || user.Type !== collaboratorTypes.USER)) || (user.roleType && (user.roleType !== globalRoles.CONTRIBUTOR || user.type !== collaboratorTypes.USER))) {
                        return;
                    }

                    // Determine the number of total contributors.
                    // This is done here because the scope variables may not be available when this directive first loads.
                    if (scope.numContributors === null) {
                        scope.numContributors = findNumContributors(scope.collaborators, scope.sharedPrincipals);
                    }

                    // Check to see whether all contributors are selected to determine whether to select or unselect the "Request all" box.
                    if (user.feedbackRequested) {
                        numFeedbackRequests++;
                        scope.feedbackRequested = true;
                        scope.allFeedbackRequested = scope.numContributors === numFeedbackRequests;
                    } else {
                        numFeedbackRequests--;
                        scope.feedbackRequested = numFeedbackRequests !== 0;
                        scope.allFeedbackRequested = false;
                    }
                };

                function findNumContributors(collaborators, sharedPrincipals) {
                    var numCollaborators = collaborators.length,
                        numDirectShares = (sharedPrincipals.direct ? sharedPrincipals.direct.length : 0),
                        totalNumber = 0,
                        directSharedPrincipals = (sharedPrincipals.direct ? sharedPrincipals.direct : []);

                    for (var i = 0; i < numCollaborators; i++) {
                        if (collaborators[i].roleType === globalRoles.CONTRIBUTOR && collaborators[i].type === collaboratorTypes.USER) {
                            totalNumber++;
                        }
                    }

                    for (var j = 0; j < numDirectShares; j++) {
                        if (directSharedPrincipals[j].Role === globalRoles.CONTRIBUTOR && directSharedPrincipals[j].Type === collaboratorTypes.USER) {
                            totalNumber++;
                        }
                    }

                    return totalNumber;
                }

                scope.$watch('allFeedbackRequested', function() {
                    if (!scope.sharedPrincipals) {
                        return;
                    }

                    if (scope.numContributors === null) {
                        scope.numContributors = findNumContributors(scope.collaborators, scope.sharedPrincipals);
                    }

                    // Account for the case where allFeedbackRequested is set to false automatically and not through a user click.
                    // In this case, we don't want to update any individual users' feedbackRequest fields.
                    if (!scope.allFeedbackRequested && numFeedbackRequests !== scope.numContributors) {
                        return;
                    }

                    setFeedbackRequestForAllContributors(scope.allFeedbackRequested, scope.collaborators, scope.sharedPrincipals.direct);
                });

                function setFeedbackRequestForAllContributors(allFeedbackRequested, collaborators, directSharedPrincipals) {
                    var numCollaborators = collaborators.length,
                        numDirectShares = directSharedPrincipals.length,
                        contributor;

                    for (var i = 0; i < numCollaborators; i++) {
                        contributor = collaborators[i];
                        if (contributor.roleType === globalRoles.CONTRIBUTOR && contributor.type === collaboratorTypes.USER) {
                            contributor.feedbackRequested = allFeedbackRequested;
                        }
                    }

                    for (var j = 0; j < numDirectShares; j++) {
                        contributor = directSharedPrincipals[j];
                        if (contributor.Role === globalRoles.CONTRIBUTOR && contributor.Type === collaboratorTypes.USER) {
                            contributor.feedbackRequested = allFeedbackRequested;
                        }
                    }

                    numFeedbackRequests = allFeedbackRequested ? scope.numContributors : 0;
                    scope.feedbackRequested = allFeedbackRequested;
                }

                scope.roleToHumanString = function(role) {
                    switch (role) {
                        case globalRoles.VIEWER:
                            return $translate.instant('RIGHT_NAV.VIEWER');
                        case globalRoles.CONTRIBUTOR:
                            return $translate.instant('RIGHT_NAV.CONTRIBUTOR');
                        case globalRoles.COOWNER:
                            return $translate.instant('RIGHT_NAV.CO_OWNER');
                        default:
                            return $translate.instant('RIGHT_NAV.OWNER');
                    }
                };

                scope.addCollaboratorWrapper = function(collaborator) {
                    switch (collaborator.type) {
                        case collaboratorTypes.USER:
                        case collaboratorTypes.INVITE:
                            addUserCollaboratorWrapper(collaborator);
                            break;
                        case collaboratorTypes.GROUP:
                            addGroupCollaboratorWrapper(collaborator);
                            break;
                    }

                    scope.userInput.searchQuery = '';
                };

                scope.getRole = function(collaborator) {
                    return collaborator.roleType;
                };

                scope.changeRole = function(type) {
                    scope.role = type;
                };

                scope.removePermission = function(collaborator) {
                    //if the collaborator has a Role property, then it means he is already shared.
                    if (collaborator.Role && collaborator.Type) {
                        if (collaborator.Role === globalRoles.CONTRIBUTOR && collaborator.Type === collaboratorTypes.USER) {
                            processRemoveContributor(collaborator);
                        }

                        scope.removedCollaborators.push(collaborator);
                        collaborator.isRemoved = true;
                    }

                    //if the collaborator has a roleType property, then it means he is newly shared.
                    if (collaborator.roleType) {
                        if (collaborator.roleType === globalRoles.CONTRIBUTOR && collaborator.type === collaboratorTypes.USER) {
                            processRemoveContributor(collaborator);
                        }

                        var index = scope.collaborators.indexOf(collaborator);
                        if (index !== -1) {
                            scope.collaborators.splice(index, 1);
                        }
                    }
                };

                scope.updateRole = function(collaborator, type) {
                    //if the collaborator has a Role property, then it means he is already shared.
                    if (collaborator.Role) {
                        if (collaborator.Role === globalRoles.CONTRIBUTOR && type !== globalRoles.CONTRIBUTOR && collaborator.Type === collaboratorTypes.USER) {
                            processRemoveContributor(collaborator);
                        } else if (type === globalRoles.CONTRIBUTOR && collaborator.Type === collaboratorTypes.USER) {
                            processNewContributor(collaborator);
                        }

                        //if the collaborator has been grayed out, then we can now undo the change and add the role for the collaborator again.
                        if (collaborator.isRemoved) {
                            var index = scope.removedCollaborators.indexOf(collaborator);
                            scope.removedCollaborators.splice(index, 1);
                            collaborator.isRemoved = false;
                        }
                        collaborator.Role = type;

                    }

                    scope.collaboratorRoleUpdated = true;

                    //if the collaborator has a roleType property, then it means he is newly shared.
                    if (collaborator.roleType) {
                        if (collaborator.roleType === globalRoles.CONTRIBUTOR && type !== globalRoles.CONTRIBUTOR && collaborator.type === collaboratorTypes.USER) {
                            processRemoveContributor(collaborator);
                        } else if (type === globalRoles.CONTRIBUTOR && collaborator.type === collaboratorTypes.USER) {
                            processNewContributor(collaborator);
                        }
                        collaborator.roleType = type;
                    }
                };

                function processRemoveContributor(contributor) {
                    if (scope.numContributors === null) {
                        scope.numContributors = findNumContributors(scope.collaborators, scope.sharedPrincipals);
                    }

                    if (contributor.feedbackRequested) {
                        numFeedbackRequests--;
                        contributor.feedbackRequested = false;
                    }

                    scope.numContributors--;
                    if (numFeedbackRequests === 0) {
                        scope.feedbackRequested = false;
                    } else if (numFeedbackRequests === scope.numContributors) {
                        scope.allFeedbackRequested = true;
                    }
                }

                function processNewContributor(contributor) {
                    if (scope.numContributors === null) {
                        scope.numContributors = findNumContributors(scope.collaborators, scope.sharedPrincipals);
                    }

                    if (scope.allFeedbackRequested) {
                        numFeedbackRequests++;
                        contributor.feedbackRequested = true;
                    }

                    scope.numContributors++;
                }
            }
        };
    }
}());
